import { BasicRequest } from "./basicRequest";

export class DeleteUserRequest extends BasicRequest{

    public userId! : number;
    public physicalDelete : boolean = false;

    constructor(){
        super();
    }
}